export default __webpack_public_path__ + "static/media/incidents-phone.3b0c5d2a.svg";